<template>
	<n-list v-if="leaves.length > 0">
		<n-list-item v-for="leave in leaves" class="leave-item">
			<n-thing>
				<template #description>
					<div class="d-flex flex-row justify-content-between">
						<div>
							{{ `Du : ${formatDate(leave.start)} au ${formatDate(leave.end)}` }}
						</div>
						<div v-if="showStatus" class="ms-3">
							<n-tooltip v-if="leave.status === 'validated'" trigger="hover">
								<template #trigger>
									<n-tag round :bordered="false" type="success">
										<i class="fas fa-check me-1"></i>
										Validé
									</n-tag>
								</template>
								Validé le {{ formatDate(leave.validate_at) }} par {{ leave.expand.validator.name }}
							</n-tooltip>
							<n-tag v-if="leave.status === 'pending'" round :bordered="false" type="info">
								<i class="fas fa-clock me-1"></i>
								En attente
							</n-tag>
							<n-tooltip v-if="leave.status === 'canceled'" trigger="hover">
								<template #trigger>
									<n-tag round :bordered="false">
										<i class="fas fa-ban me-1"></i>
										Annulé
									</n-tag>
								</template>
								Annulé le {{ formatDate(leave.cancel_at) }}
							</n-tooltip>
							<n-tooltip v-if="leave.status === 'refused'" trigger="hover">
								<template #trigger>
									<n-tag type="error" round :bordered="false">
										<i class="fas fa-times me-1"></i>
										Refusé
									</n-tag>
								</template>
								Refusé le {{ formatDate(leave.refuelling_at) }}
							</n-tooltip>
						</div>
					</div>
					<div class="leave-meta mt-2">
						<span class="text-muted">
							<i class="fa fa-calendar me-1"></i> {{ formatDate(leave.created) }}
						</span>
					</div>
					<div v-if="showedLeavesDetails.includes(leave.id)" class="leave-details mt-3">
						<div class="comments-section">
							<div v-if="leave.comment" class="comment">
								<p class="fw-bold mb-1">Commentaire de la demande :</p>
								<p style="white-space: pre;">{{ leave.comment }}</p>
							</div>
							<div v-if="leave.validatorcomment" class="validator-comment">
								<p class="fw-bold mb-1">Commentaire de la validation :</p>
								<p style="white-space: pre;">{{ leave.validatorcomment }}</p>
							</div>
						</div>

						<div v-if="leave.justificatifs.length" class="attachments-section mt-2">
							<p class="fw-bold">Pièces jointes :</p>
							<ul class="attachments-list">
								<li v-for="justificatif in leave.justificatifs">
									<a target="_blank" :href="justificatif.url" class="attachment-link">
										<i class="fas fa-paperclip me-1"></i>
										{{ justificatif.title }}
									</a>
								</li>
							</ul>
						</div>

						<div class="mt-2">
							<n-button size="small" class="me-2" type="info"
									  @click="showedLeavesDetails = showedLeavesDetails.filter(e => e !== leave.id)">
								<i class="fas fa-chevron-up me-1"></i> Masquer
							</n-button>
							<n-popconfirm v-if="leave.status === 'pending'"
										  @positive-click="handleConfirmeCancelLeave(leave)">
								<template #trigger>
									<n-button size="small" type="error">
										<i class="fas fa-times me-1"></i> Annuler la demande
									</n-button>
								</template>
								Es tu sûr de vouloir annuler la demande ?
							</n-popconfirm>
						</div>
					</div>

					<div v-else-if="leave.comment || leave.justificatifs.length > 0" class="mt-2">
						<n-button size="small" class="me-2" type="info" @click="showedLeavesDetails.push(leave.id)">
							<i class="fas fa-chevron-down me-1"></i> Détails
						</n-button>
						<n-popconfirm v-if="leave.status === 'pending'"
									  @positive-click="handleConfirmeCancelLeave(leave)">
							<template #trigger>
								<n-button size="small" type="error">
									<i class="fas fa-times me-1"></i> Annuler la demande
								</n-button>
							</template>
							Es tu sûr de vouloir annuler la demande ?
						</n-popconfirm>
					</div>
					<div v-else-if="leave.status === 'pending'" class="mt-2">
						<n-popconfirm @positive-click="handleConfirmeCancelLeave(leave)">
							<template #trigger>
								<n-button size="small" type="error">
									<i class="fas fa-times me-1"></i> Annuler la demande
								</n-button>
							</template>
							Es tu sûr de vouloir annuler la demande ?
						</n-popconfirm>
					</div>
				</template>
			</n-thing>
		</n-list-item>
	</n-list>
</template>

<script setup>
import {NButton, NIcon, NList, NListItem, NPopconfirm, NSpace, NTag, NThing, NTooltip} from "naive-ui";
import {formatDate} from '../plugins/helpers.js'
import {onMounted, ref} from "vue";
import {useStore} from "vuex";

const store = useStore();

defineProps({
	leaves: {
		type: Array,
		required: true
	},
	showStatus: {
		type: Boolean,
		default: true
	}
});

const showedLeavesDetails = ref([]);

const handleConfirmeCancelLeave = (leave) => {
	store.dispatch('cancelLeave', leave.id)
}

onMounted(() => {
	store.dispatch('fetchLeaves')
});
</script>